module.exports = __webpack_public_path__ + "img/podium_2064.46689159.jpg";